import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import TableFilterInput from '../../../../../components/_table/TableFilterInput';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  추천 검색 키워드에 연결된 검색 키워드 아이템 리스트 컬럼
 */
export const columns = (data) => {
  const { isFilter, filterOption, sortOption, onFilter } = data;

  return [
    {
      title: <TableColumnTitle title={'검색 키워드 ID'} filterValue={filterOption.searchWordId} />,
      dataIndex: 'id',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'검색 키워드 검색'}
          option={filterOption.searchWordId}
          confirm={confirm}
          onFilter={(searchWordId) => onFilter({ searchWordId })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'검색 키워드'} filterValue={filterOption.word} />,
      dataIndex: 'word',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'검색 키워드 검색'}
          option={filterOption.word}
          confirm={confirm}
          onFilter={(word) => onFilter({ word })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'검색 누적 횟수'} />,
      dataIndex: 'count',
      sorter: isFilter,
      sortOrder: sortOption['count'],
    },
    {
      title: <TableColumnTitle title={'검색 키워드 생성일'} />,
      dataIndex: 'createDate',
      sorter: isFilter,
      sortOrder: sortOption['createDate'],
      render: (value) => setDateFormat(value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};
